<template src="./formerror.html"></template>

<script>
  export default {
    name: 'FormError'
  }
</script>

<style scoped>

</style>
